export const REGEXP = {
  IMG: /^image\/(gif|jpe?g|a?png|svg|webp|bmp|vnd\.microsoft\.icon)/i,
  YOUTUBE_FULL: /^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/,
  YOUTUBE_SHARE: /^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/,
  YOUTUBE_SHORT: /youtu(be\.com|\.be)$/,
  TIKTOK_SHORT: /tiktok/,
  TIKTOK_CODE_EMBEDED: /\bblockquote\b.*\btiktok-embed\b.*\bcite\b/,
  TIKTOK_CODE_LINK: /cite="([^"]*)"/,
  HTTPS: /^https?:\/\//,
  HTTPS_URL:
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,
  OPUS_ID: /^(GRP-|\d+)\d+$/,
  SPOTIFY_URL: /^(https:\/\/open.spotify.com\/artist\/)\w+/,
  EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
}
